import React, { useContext, useState } from 'react';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material';

import { AuthContext, stopPropagationForTab } from 'components';


export const StoreNameModal = (props) => {
  const { onClose } = props;
  const [ open, setOpen ] = useState(false);
  const [ saving, setSaving ] = useState(false);
  const { account, selectedStore, updateStoreName, notify } = useContext(AuthContext);
  const [ value, setValue ] = useState(account?.acctStores?.[selectedStore]?.displayName || "")


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSaving(false);
    if (onClose) {
      onClose();
    }
  }

  const handleSave = () => {
    updateStoreName(selectedStore, value, () => {
      handleClose()
      notify({
        message: 'Store name has been updated'
      })
    })
  }

  
  return (
    <>
      {React.cloneElement(props.children, { onClick: handleOpen })}
      <Dialog fullWidth maxWidth={'sm'} onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Change "{account?.acctStores?.[selectedStore]?.displayName || ""}" store name</DialogTitle>
        <DialogContent>
          {/*  */}
          <TextField
            sx={{ mt: 2 }}
            fullWidth
            multiline
            autoFocus
            variant='standard'
            value={value}
            onChange={(e) => { setValue(e.target.value) }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}